// Bookwhen booking calendar embed (per-page schedule/booking)
import { motion } from "framer-motion";
import { Calendar } from "lucide-react";

export const BookwhenEmbed = ({
  slug,
  title = "Book Online",
  subtitle,
  bgClass = "bg-muted",
  testId = "bookwhen-embed",
}) => {
  return (
    <section id="book" className={`py-16 px-6 md:px-12 ${bgClass}`} data-testid={testId}>
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-8"
        >
          <Calendar className="w-8 h-8 text-gold mx-auto mb-4" />
          <h2 className="font-heading text-2xl md:text-3xl text-neutral-800 mb-3">{title}</h2>
          {subtitle && <p className="text-neutral-600 max-w-xl mx-auto">{subtitle}</p>}
        </motion.div>

        <div className="bg-white rounded-2xl border border-gold/10 overflow-hidden p-2 md:p-4 shadow-sm">
          <iframe
            src={`https://bookwhen.com/${slug}/iframe`}
            title={`${title} — booking calendar`}
            frameBorder="0"
            scrolling="yes"
            seamless="seamless"
            style={{ display: "block", border: "none", width: "100%", height: "900px" }}
            data-testid={`${testId}-iframe`}
          />
        </div>
      </div>
    </section>
  );
};

export default BookwhenEmbed;
